const theme = {
	background1: '#36393E',
	background2: '#2B2C30',
	background3: '#202225',

	primary1: '#4DAC74',

	text1: '#D1D1D1',
	text2: '#4E5158',

	// The product's dark/green identity is fixed by the logo and the app, so the
	// work here is widening it into a system: a warmer off-white so long text
	// reads like paper rather than a terminal, plus hairlines for dividers.
	chalk: '#E9E7E2',
	rule: 'rgba(233, 231, 226, 0.13)',
	ruleStrong: 'rgba(233, 231, 226, 0.26)',

	danger: 'rgb(255, 78, 78)',

	monoFont:
		'IBM Plex Mono,ui-monospace,SFMono-Regular,Menlo,Consolas,monospace',
	primaryFont:
		'Nunito,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif',
	headerFont:
		'Paytone One,-apple-system,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,sans-serif',
};

export default theme;
